 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		226: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + {"0":"1a4fc3c","1":"b36874f","2":"f7ad0e5","3":"c0bc263","4":"19fb90d","5":"6e9aa7d","6":"38a055b","7":"eea1076","8":"600c36e","9":"0b3db41","10":"c135a25","11":"6b5f67a","12":"e23761d","13":"283af99","14":"5eeecac","15":"56baee4","16":"1540744","17":"4816d68","18":"b82de72","19":"2114548","20":"100cc7a","21":"6b3098f","22":"6adc24b","23":"c402717","24":"8717360","25":"d64cf72","26":"feb5773","27":"5ddb147","28":"f05ae9e","29":"357a23b","30":"dbbbf8e","31":"dad8b6f","32":"43df235","33":"8f57722","34":"b5babc9","35":"a81d19a","36":"d434277","37":"8538b62","38":"8addfc0","39":"b23925a","40":"511c71b","41":"86a0cc6","42":"6c8a89b","43":"3adb1e9","44":"2526fce","45":"877fde3","46":"a9042d8","47":"4226db2","48":"0f70cd5","49":"3e3828f","50":"3badd22","51":"7b687f2","52":"1a48b65","53":"ac21c6e","54":"48fc649","55":"5635ffc","56":"238f013","57":"358190d","58":"e7eda3c","59":"82b13f1","60":"3d010ec","61":"c8439e9","62":"a391567","63":"a01407e","64":"c5f9cde","65":"1e0e39c","66":"cfd1893","67":"bf03d26","68":"7a16138","69":"c9451f9","70":"ddcb622","71":"928b174","72":"0e96d1a","73":"b66e0f0","74":"3fe0e48","75":"c6291ba","76":"e57b475","77":"9addf23","78":"f5f6e84","79":"951d7f1","80":"a60744c","81":"503b370","82":"2e54292","83":"422d56c","84":"f5bf31c","85":"a7dbcdf","86":"f843897","87":"cf2971e","88":"d32f98d","89":"54d065b","90":"e35bcb3","91":"b7b9c94","92":"615b36d","93":"e0354f2","94":"1d5d9d3","95":"c6845d6","96":"cf18f47","97":"274c198","98":"2c6f381","99":"196e854","100":"10a198b","101":"1d4d438","102":"fac7cfe","103":"8707e49","104":"dcd99a3","105":"43229b0","106":"35dcd6a","107":"5995c76","108":"ad5b032","109":"6e36912","110":"b9d41eb","111":"9fe8133","112":"2ff5a0d","115":"684ca93","116":"6d676cc","117":"eae8aff","118":"411d902","119":"3a3b80e","120":"056934b","121":"130763f","122":"d0b9822","123":"44a4e0b","124":"7acb8d5","125":"6aee6e1","126":"f8485ba","127":"03fa0fb","128":"e7ab3f8","129":"c689609","130":"34df862","131":"e0d714e","132":"75c7a89","133":"a78a140","134":"7023fd9","135":"cc5633b","136":"ed8649e","137":"feee4c6","138":"47b163a","139":"3a57787","140":"124efd3","141":"e88d84f","142":"2dabcc5","143":"e7d5708","144":"3881807","145":"784f531","146":"b85e2a1","147":"cc5071b","148":"369edcd","149":"94d1d59","150":"ba16c4d","151":"db7fa72","152":"3267a6e","153":"ba7a3ad","154":"2b8979b","155":"759f77e","156":"d520dac","157":"aa12801","158":"601f000","159":"3578b09","160":"347a594","161":"1fb1bb1","162":"2023399","163":"97b2d6a","164":"94d3e95","165":"00110c1","166":"5bb2f8a","167":"524c149","168":"1508283","169":"beb8c3b","170":"f436199","171":"7674087","172":"5b87633","173":"6d545bf","174":"110213a","175":"1b36523","176":"818ef70","177":"127f2ad","178":"1aa3ed5","179":"96ec92b","180":"cf1b0d7","181":"f026a8c","182":"8cd09d2","183":"a164f58","184":"5f198fc","185":"77db6fa","186":"6a18ca5","187":"d37112b","188":"e671654","189":"5df7ab8","190":"a88cc80","191":"334384a","192":"412c142","193":"2fb79e4","194":"3223b17","195":"e8d9e91","196":"faea12e","197":"f204c48","198":"76dc92f","199":"9612804","200":"7ecfaf6","201":"429afa5","202":"4c80fdd","203":"82a6600","204":"ce643b9","205":"e1430cd","206":"5bfd766","207":"ea4c59d","208":"dc2ee32","209":"b28ce1c","210":"f5c0c78","211":"ae6d745","212":"2c6eede","213":"aa591e0","214":"38788de","215":"2c0b14d","216":"5c39aaa","217":"6e2e985","218":"96cf026","219":"865dc36","220":"bcea56a","221":"6cebcb7","222":"ab80bbd","223":"22b325e","224":"1fe90d9","225":"2f15d6e","228":"0674470","229":"a2c0440","230":"6436366","231":"3efe75b","232":"ac5bf25","233":"c502102","234":"379368d","235":"9d33fe6","236":"fafa811","237":"e5a269f","238":"4dfa156","239":"df31369","240":"5b1be0e","241":"15e1384","242":"243349c","243":"8407011","244":"f13fd25","245":"224702e","246":"6263a53","247":"c01c174","248":"5a30eaf","249":"fc26a7a","250":"e638c72","251":"b3213bf","252":"fbf9d1e","253":"15eedac","254":"4a44141","255":"59ef697","256":"54f8d6d","257":"a516969","258":"6202166","259":"f235ef0","260":"f8d8ab4","261":"af681cd","262":"0a126e4","263":"2e92a2c","264":"03a2c3b","265":"bd1057f","266":"7e19290","267":"0fb699d","268":"89b16f1","269":"2d1b92e","270":"43bd9e1","271":"cd57655","272":"e66eb5e","273":"146b085","274":"f484a29","275":"fb84948","276":"9153323","277":"13bb062","278":"153b115","279":"e8b19a0","280":"247a563","281":"3c0a079","282":"4419360","283":"5ef5e14","284":"e7f4a20","285":"58c0f46","286":"914d0a1","287":"e26be2d","288":"2737ff4","289":"e9bdd65","290":"7769df9","291":"9cb657d","292":"3793150","293":"f975c1b","294":"57ec6e7","295":"e5051e8","296":"c51ccde","297":"e8355df","298":"c6e43d1","299":"c41ada5","300":"5e12cd7","301":"3b0f246","302":"4fd5e1a","303":"1312287","304":"7e46a69","305":"1065567","306":"6fa57c9","307":"e176160","308":"a16106e","309":"16f86c2","310":"986281e","311":"97dfc39","312":"d58722a","313":"90cb706","314":"402c3df","315":"c8aef1a","316":"d86aaac","317":"1f5e94c","318":"4bdbea8","319":"f104c06","320":"65a249b","321":"d2d0ef9","322":"b4a7d3d","323":"869f008","324":"9419304","325":"47e577e","326":"49078eb","327":"84fe6c6","328":"efd3991","329":"4e1336c","330":"ece4ee1","331":"a5efb9c","332":"f0ae267","333":"a5c64fe","334":"fc24408","335":"2e4bc04","336":"c0b0d1e","337":"aea293a","338":"66a05a6","339":"a8378e4"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://d1mf56q6wc1y19.cloudfront.net/channels2022/220519/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
